// @flow
import * as React from 'react'
import cn from 'classnames'

import { withTranslation, Trans } from 'react-i18next'
import { Store } from 'Store'
import { Currency } from 'i18n/NumberFormatter'
import { formatDateTime } from 'i18n/DateFormat'

import PromoVoucher from 'components/PromoVoucher'
import usePromoCode from 'util/hooks/usePromoCode'

import styles from './styles.module.scss'
import withTheme from 'hoc/withTheme'
import themes from './themes/__supportedThemes.js'

import transDomain from './translations/index.translations'
import EventLogo from 'components/MainLogo/EventLogo'

function PromoService (props) {
    const promoCode = usePromoCode()
    const { state } = React.useContext(Store)
    const { t, theme } = props
    const currencyFormatter = Currency(state.currency, state.locale)

    return (
        <div className={styles.container}>
            <div className={styles.topContainer}>
                <div className={styles.topArea}>
                    <div className={styles.logo}>
                        <EventLogo
                            primaryColor={theme.colors.primary}
                            secondaryColor={theme.colors.ternary}
                            ternaryColor={theme.colors.ternary}
                            width="auto"
                            height="auto"
                            viewBox="0 0 100% 100%"
                        />
                    </div>

                    <span className={styles.text}>
                        <div className={styles.offerTitle}>{t('offer.title')}</div>
                        <div className={styles.offerDescription} style={{ color: theme.colors.primary }}>
                            {t('offer.description', {
                                expiryDate: formatDateTime(state.campaign.expiryDate, 'long')
                            })}
                        </div>
                    </span>
                </div>

                <PromoVoucher width="100%" promoCode={promoCode}/>
            </div>

            <div className={styles.cars}>
                <img src={theme.cars} alt=""/>
            </div>

            <div className={styles.bottomContainer}>
                <h1 className={styles.title} style={{ color: theme.titleColor }}>
                    <Trans t={t} i18Key="title">
                        <strong>On Now!</strong> For Select Clients
                    </Trans>
                </h1>

                <p className={styles.description} style={{ color: theme.colors.textColor }}>
                    {t('description', {
                        expiry: formatDateTime(state.campaign.expiryDate, 'long'),
                        voucherName: state.campaign.incentives.voucher.name,
                        voucherValue: currencyFormatter.format(state.campaign.incentives.voucher.value),
                        voucherValueRaw: state.campaign.incentives.voucher.value,
                        voucherType: state.campaign.incentives.voucher.type
                    })}
                </p>

                <div className={styles.bottomRibbon} style={{ backgroundColor: theme.bottomRibbonBackgroud }}>
                    <div className={styles.bottomRibbonLabel}>{t('visit')}</div>
                    <div className={styles.bottomRibbonValue} style={{ color: theme.labelTextColor }}>www.{window.location.host}/{window.location.pathname.split('/')[1]}</div>
                    <div className={styles.bottomRibbonLabel}>{t('promo_code')}</div>
                    <div className={cn(styles.bottomRibbonValue, styles.bottomRibbonPromoCode)} style={{ color: theme.labelTextColor }}>{promoCode}</div>
                </div>

                <div className={styles.footerContainer}>
                    <div className={styles.footerDisclaimer} style={{ color: theme.colors.textColor }}>
                        {t('disclaimer')}
                    </div>

                    {theme.manufacturerLogo && (
                        <div className={cn(styles.footerLogo, { [styles.bigLogo]: theme.bigLogo })}>
                            <img src={theme.manufacturerLogo} alt=""/>
                        </div>
                    )}
                </div>
            </div>
        </div>
    )
}

export default withTheme(themes)(withTranslation(transDomain)((PromoService)))
